import { POIS_FILTERS } from './filters.constants'

export const filterTypeIsKnown = type => Object.keys(POIS_FILTERS).includes(type)
